import PropTypes from 'prop-types';
import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
  PDFViewer,
  Note,
  Layp,
  BlobProvider,
  pdf
} from '@react-pdf/renderer';
import moment from 'moment-timezone';
import moment_ from 'moment';
import 'moment/min/locales';
import indexFinder from '../utils/indexFinder';
import { getBaseURL, getAPIURL } from '../utils/envGetter';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    paddingBottom: '2.5cm'
  },
  pageWithPaddingTop: {
    flexDirection: 'column',
    paddingTop: '2cm',
    paddingBottom: '2.5cm'
  },
  pageWaterMarked: {
    flexDirection: 'column',
    paddingBottom: '2.5cm'
  },
  pageWithPaddingTopWaterMarked: {
    flexDirection: 'column',
    paddingTop: '2cm',
    paddingBottom: '2.5cm'
  },
  watermarked: {
    transform: 'rotate(-35deg)',
    zIndex: 1,
    position: 'absolute',
    marginLeft: '25%',
    marginTop: '50%'
  },
  section: {
    marginBottom: 5,
    flexGrow: 1
  },
  subSection: {
    marginBottom: 5,
    flexGrow: 1
  },
  textRegular: {
    fontSize: 9,
    fontFamily: 'Bookos',
    fontWeight: 'normal',
    color: '#424242'
  },
  textBold: {
    fontSize: 10,
    fontFamily: 'Bookos',
    fontWeight: 'bold',
    color: '#424242'
  },
  textTitle: {
    fontSize: 11,
    fontFamily: 'Bookos',
    fontWeight: 'black',
    color: '#424242'
  }
});

const PDFRendererForBackup = ({ Header, BodyPermohonan, informations, decoded, layanan }) => {
  const data = '13';
  const ROWHEIGHT = 90;
  const PADDINGTEXT = 4;
  const FONTSIZE = 12;
  const SUBFONTSIZE = 10;
  const SUBSUBFONTSIZE = 6.5;
  const BORDERCOLOR = '#454F5B';

  const now = moment.tz('Asia/Jakarta');

  const appName = informations.find((item) => item.id === 'app_name')?.answer || 'Nama Aplikasi';
  const appAddress =
    informations.find((item) => item.id === 'app_address')?.answer || 'Alamat Aplikasi';
  const appRequirements =
    informations.find((item) => item.id === 'backup_requirements')?.answer || 'Keperluan Backup';
  const appOpd = informations.find((item) => item.id === 'opd_responsible')?.answer || 'Nama OPD';

  const filterBiodata = [
    'asn_responsible',
    'nip_responsible',
    'jabatan_responsible',
    'opd_responsible'
  ];
  const filteredBiodata = informations.filter((item) => filterBiodata.includes(item.id));

  const filterKonten = [
    'nama_penerima',
    'nipnik_penerima',
    'jabatan_penerima',
    'hp_penerima',
    'email_penerima'
  ];
  const filteredKonten = informations.filter((item) => filterKonten.includes(item.id));

  function PenandaTangan({ informations, decoded, layanan }) {
    let recommenderNama;
    let recommenderNIP;
    if (decoded.selectedRequirement?.attributes?.question_id === 'backup') {
      recommenderNama = layanan.meta?.data_permohonan?.metadata?.answers?.asn_responsible;
      recommenderNIP = layanan.meta?.data_permohonan?.metadata?.answers?.nip_responsible;
    } else {
      recommenderNama = layanan.meta?.data_permohonan?.metadata?.answers?.requestor_nama;
      recommenderNIP = layanan.meta?.data_permohonan?.metadata?.answers?.requestor_nip;
    }
    const recommenderInstansi =
      layanan.meta?.data_permohonan?.metadata?.answers?.requestor_instansi;

    function Approver({ informations, decoded, layanan }) {
      return (
        <View
          style={{
            width: '50%',
            paddingTop: 10,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <View
            style={{
              height: 50,
              alignItems: 'center',
              paddingBottom: 10,
              flexDirection: 'column',
              justifyContent: 'flex-end'
            }}
          >
            <Text
              style={{
                fontSize: 9,
                fontFamily: 'Bookos',
                fontWeight: 'normal',
                textAlign: 'center'
              }}
            >
              KEPALA
            </Text>

            {/* <Text
                style={{
                  fontSize: 9,
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  textAlign: 'center'
                }}
              >
                {recommenderInstansi}
              </Text> */}
          </View>

          <View style={{ paddingBottom: 5 }}>
            {/* decoded.modeTandaTangan === 'tte' disable remove qrcode */}
            {decoded.modeTandaTangan === 'tte' ? (
              <Image
                allowDangerousPaths
                src={`${getAPIURL()}/qrcodes?id=${
                  layanan?.meta?.[decoded.selectedRequirement.type]?.metadata?.qr_code_path?.split(
                    '/'
                  )[5]
                }&year=${
                  layanan?.meta?.[decoded.selectedRequirement.type]?.metadata?.qr_code_path?.split(
                    '/'
                  )[3]
                }&month=${
                  layanan?.meta?.[decoded.selectedRequirement.type]?.metadata?.qr_code_path?.split(
                    '/'
                  )[4]
                }`}
                style={{ width: 75, height: 75 }}
              />
            ) : (
              <View style={{ width: 75, height: 75 }} />
            )}
          </View>

          <Text
            style={{
              fontSize: 9,
              fontFamily: 'Bookos',
              fontWeight: 'normal',
              textDecoration: 'underline',
              textAlign: 'center'
            }}
          >
            {recommenderNama}
          </Text>
          <Text
            style={{
              fontSize: 9,
              fontFamily: 'Bookos',
              fontWeight: 'normal',
              textAlign: 'center'
            }}
          >
            NIP. {recommenderNIP}
          </Text>
        </View>
      );
    }

    return (
      <View
        break
        style={{
          paddingTop: 10,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <View
          style={{
            width: '50%',
            paddingTop: 10,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        />

        <Approver informations={informations} decoded={decoded} layanan={layanan} />
      </View>
    );
  }
  return (
    <View>
      <View>{Header}</View>
      <View
        fixed
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          border: 0,
          borderWidth: 0,
          marginBottom: 5,
          width: '100%',
          borderColor: BORDERCOLOR
        }}
      >
        <Text
          style={{
            ...styles.textRegular,
            width: '100%',
            fontFamily: 'Bookos',
            fontWeight: 'normal',
            paddingLeft: 2,
            maxLines: 2,
            textOverflow: 'ellipsis',
            textAlign: 'justify'
          }}
        >
          Dengan hormat, saya yang bertandatangan di bawah ini :
        </Text>
      </View>
      <View
        style={{
          ...styles.section,
          borderTop: 0,
          borderLeft: 0,
          borderRight: 0,
          borderColor: BORDERCOLOR
        }}
      >
        {filteredBiodata.map((item, index) => (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              flexWrap: 'wrap',
              borderBottom: 0,
              minHeight: 25,
              borderColor: BORDERCOLOR
            }}
          >
            <View
              style={{
                padding: 2,
                minWidth: '25%',
                maxHeight: 150,
                minHeight: 25,
                justifyContent: 'center',
                borderColor: BORDERCOLOR
              }}
            >
              <Text
                style={{
                  ...styles.textRegular,
                  width: '25%',
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  paddingLeft: 2,
                  maxLines: 2,
                  textOverflow: 'ellipsis'
                }}
              >
                {item.label}
              </Text>
            </View>
            <View
              style={{
                padding: 2,
                maxHeight: 150,
                minHeight: 25,
                justifyContent: 'center',
                minWidth: '75%',
                borderLeft: 0
              }}
            >
              <Text
                style={{
                  ...styles.textRegular,
                  width: '75%',
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  paddingLeft: 2
                }}
              >
                : {item.answer}
              </Text>
            </View>
          </View>
        ))}
      </View>
      <View
        fixed
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          border: 0,
          borderWidth: 0,
          marginBottom: 5,
          width: '100%',
          borderColor: BORDERCOLOR
        }}
      >
        <Text
          style={{
            ...styles.textRegular,
            width: '100%',
            fontFamily: 'Bookos',
            fontWeight: 'normal',
            paddingLeft: 2,
            textAlign: 'justify'
          }}
        >
          Bertindak sebagai wali data dan pengelola aplikasi {appName} {appAddress}
        </Text>
      </View>
      <View
        fixed
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          border: 0,
          borderWidth: 0,
          marginBottom: 5,
          width: '100%',
          borderColor: BORDERCOLOR
        }}
      >
        <Text
          style={{
            ...styles.textRegular,
            width: '100%',
            fontFamily: 'Bookos',
            fontWeight: 'normal',
            paddingLeft: 2,
            textAlign: 'justify'
          }}
        >
          Melalui surat ini mengajukan permohonan untuk diberikan backup database dari aplikasi
          tersebut untuk keperluan {appRequirements} dan dilakukan pemrosesan data oleh {appOpd}.
          Adapun backup data dimaksud, agar diserahkan kepada:
        </Text>
      </View>
      <View
        style={{
          ...styles.section,
          borderTop: 0,
          borderLeft: 0,
          borderRight: 0,
          borderColor: BORDERCOLOR
        }}
      >
        {filteredKonten.map((item, index) => (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              flexWrap: 'wrap',
              borderBottom: 0,
              minHeight: 25,
              borderColor: BORDERCOLOR
            }}
          >
            <View
              style={{
                padding: 2,
                minWidth: '25%',
                maxHeight: 150,
                minHeight: 25,
                justifyContent: 'center',
                borderColor: BORDERCOLOR
              }}
            >
              <Text
                style={{
                  ...styles.textRegular,
                  width: '25%',
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  paddingLeft: 2,
                  maxLines: 2,
                  textOverflow: 'ellipsis'
                }}
              >
                {item.label}
              </Text>
            </View>
            <View
              style={{
                padding: 2,
                maxHeight: 150,
                minHeight: 25,
                justifyContent: 'center',
                minWidth: '75%',
                borderLeft: 0
              }}
            >
              <Text
                style={{
                  ...styles.textRegular,
                  width: '75%',
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  paddingLeft: 2
                }}
              >
                : {item.answer}
              </Text>
            </View>
          </View>
        ))}
      </View>
      <View
        fixed
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          border: 0,
          borderWidth: 0,
          marginBottom: 5,
          width: '100%',
          borderColor: BORDERCOLOR
        }}
      >
        <Text
          style={{
            ...styles.textRegular,
            width: '100%',
            fontFamily: 'Bookos',
            fontWeight: 'normal',
            paddingLeft: 2,
            textAlign: 'justify'
          }}
        >
          Dengan ini kami menyatakan bertanggung jawab terhadap keamanan penggunaan data sesuai
          peraturan perundang-undangan yang berlaku khususnya di bidang Informasi dan Transaksi
          Elektronik dan Perlindungan Data Pribadi. Demikian surat permohonan ini dibuat untuk
          dipergunakan sebagaimana mestinya.
        </Text>
      </View>
      <View>
        <PenandaTangan informations={informations} decoded={decoded} layanan={layanan} />
      </View>
    </View>
  );
};

export default PDFRendererForBackup;
